import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "../../styles/footer.css";

const Footer = () => {
  return (
    <footer className="footer bg-dark text-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={3}>
            <h5 className="text-primary mb-3">Marion Livraison</h5>
            <p className="small text-muted">
              Service de livraison rapide et fiable à partir de 19,99€
            </p>
          </Col>
          <Col md={3}>
            <h6 className="mb-3">Informations légales</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/cgu" className="text-white text-decoration-none">
                  Conditions Générales d'Utilisation
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/cgv" className="text-white text-decoration-none">
                  Conditions Générales de Vente
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/mentions-legales" className="text-white text-decoration-none">
                  Mentions Légales
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/politique" className="text-white text-decoration-none">
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={3}>
            <h6 className="mb-3">Aide & Support</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/faq" className="text-white text-decoration-none">
                  FAQ
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-white text-decoration-none">
                  À propos
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/contact" className="text-white text-decoration-none">
                  Contact
                </Link>
              </li>
            </ul>
          </Col>
          <Col md={3}>
            <h6 className="mb-3">Suivez-nous</h6>
            <div className="social-links">
              <a href="#" className="text-white me-3">
                <i className="fab fa-facebook"></i> Facebook
              </a>
              <br />
              <a href="#" className="text-white me-3">
                <i className="fab fa-instagram"></i> Instagram
              </a>
              <br />
              <a href="#" className="text-white">
                <i className="fab fa-linkedin"></i> LinkedIn
              </a>
            </div>
          </Col>
        </Row>
        <hr className="my-4 bg-secondary" />
        <Row>
          <Col className="text-center">
            <p className="small text-muted mb-0">
              © {new Date().getFullYear()} Marion Livraison. Tous droits réservés.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
